import { formatEventTime } from './formatEventTime.js';
import { translation } from './translate.js';
import { currencyFormatter } from './currencyFormatter.js';

/**
 * Set Order Summary after success Payment.
 *
 * @param {OrderResponse} orderResponse - The current order object to which the coupon will be applied.
 * @returns {void} - This function does not return a value. It modifies the provided `orderResponse` object directly.
 */
export function generateOrderSummary(orderResponse) {
  const orderSummarySuccess = document.getElementById('gd__order__summary__success');
  const orderSummaryError = document.getElementById('gd__order__summary__error');
  const eventDetails = document.getElementById('gd__checkout__eventDetails');
  if (!orderSummarySuccess || !orderSummaryError || !eventDetails) {
    console.error('One element of (gd__order__summary__success, gd__order__summary__error, gd__checkout__eventDetails) not found.');
    return;
  }
  // console.trace('orderResponse:', orderResponse);
  // error handling oderResponse
  if (orderResponse?.error?.responseJson) {
    eventDetails.style.display = 'none';
    orderSummaryError.style.display = 'block';
    orderSummaryError.innerHTML = `
      <div id="gd__order__summary__error__heading">
        ${orderResponse?.error?.messageHeading ? `<h2>${orderResponse.error.messageHeading}</h2>` : ''}
      </div>
      <div id="gd__order__summary__error__details">
        ${orderResponse?.error?.responseJson?.error?.message ? `<p>${orderResponse.error.responseJson.error.message}</p>` : ''}
      </div>
      <div id="gd__order__summary__error__actions">
        <div class="button__wrapper">
          <button data-close="close__checkout__modal" class="button close-overlay">Close</button>
        </div>
      </div>
      `;
    return;
  }

  const order = Array.isArray(orderResponse?.orders) && orderResponse.orders.length > 0
    ? orderResponse.orders[0]
    : null;

  // error handling oderResponse not success or order not exist
  if (!order || !order.success) {
    eventDetails.style.display = 'none';
    orderSummaryError.style.display = 'block';
    orderSummaryError.innerHTML = `
    <div id="gd__order__summary__error__heading">
      <h2>${translation.orderSummaryErrorHeading}</h2>
    </div>
    <div id="gd__order__summary__error__details">
      <p>${translation.orderSummaryErrorDescription}</p>
    </div>
    <div id="gd__order__summary__error__actions">
      <div class="button__wrapper">
        <button data-close="close__checkout__modal" class="button close-overlay">Close</button>
      </div>
    </div>
      `;
    return;
  }

  // create orderSuccessHTML
  let orderSuccessHTML = `
    <div id="gd__order__summary__success__heading">
      <h2>${translation.orderSummarySuccessHeading}</h2>    
    </div>
    <div id="gd__order__summary__success__details">
      ${order?.id ? `<h3>${translation.order}: ${order.id}</h3>` : ''}
      ${order?.created_at ? `<div class="created_at">${translation.orderDate}: ${formatEventTime(order.created_at)}</div>` : ''}
      ${order?.coupon?.name ? `<div class="coupon_name">${translation.coupon}: ${order.coupon.name}</div>` : ''}
      ${(order?.purchase_price !== null && order?.purchase_price !== undefined) && `<div class="purchase_price">${translation.total}: ${currencyFormatter(order.purchase_price / 100)}</div>`}
    </div>
     <div id="gd__order__summary__success__tickets">
       <div id="gd__order__summary__success__tickets__heading">
         <h3>${translation.ticketOverview}</h3>
       </div>
       ${order.summary ? `<div class="summary">${order.summary}</div>` : ''}
       ${renderTickets(order)}
    </div>
    <div id="gd__order__summary__success__notes">
      <div class="note"><strong>${translation.notice}:</strong></div>
      <p>${translation.order_tickets_success}</p>
    </div>
    <div id="gd__order__summary__success__actions">
      <div class="button__wrapper">
        ${order?.order_tickets_pdf_path &&
          `<button onClick="window.open('https://api.eventive.org/${order.order_tickets_pdf_path}', '_blank')" 
              type="button" class="button">${translation.tickets}</button>`}
        ${order?.order_receipt_pdf_path &&
          `<button onClick="window.open('https://api.eventive.org/${order.order_receipt_pdf_path}', '_blank')" 
              type="button" class="button">${translation.receipt}</button>`}
          <button data-close="close__checkout__modal" class="button close-overlay">Close</button>
      </div>
    </div>
  `;
  eventDetails.style.display = 'none';
  orderSummarySuccess.innerHTML = orderSuccessHTML;
  orderSummarySuccess.style.display = 'block';
}

/**
 * Render unique tickets based on start time and venue name
 * @param {Object} orderResponse - The response object containing ticket details
 * @returns {string} - The rendered HTML string or an empty string if no valid tickets
 */
function renderTickets(orderResponse) {
  if (!orderResponse?.tickets?.length) {
    return '';
  }

  // Set to store unique combinations of start_time and venue.name
  const uniqueTickets = new Set();

  return orderResponse.tickets
    .filter(ticket => ticket?.event?.start_time && ticket?.event?.venue?.name)
    .filter(ticket => {
      // Create a unique key based on start_time and venue.name
      const ticketKey = `${ticket.event.start_time}-${ticket.event.venue.name}`;

      // Check if this combination already exists
      if (uniqueTickets.has(ticketKey)) {
        return false; // Skip this ticket if it's already in the set
      }

      // Otherwise, add this key to the set and keep this ticket
      uniqueTickets.add(ticketKey);
      return true;
    })
    .map(ticket => `       
      <div class="start_time">${translation.startTime}: ${formatEventTime(ticket.event.start_time)}</div>
      <div class="venue_name">${translation.cinema}: ${ticket.event.venue.name}</div>
      ${ticket?.pass?.name ? (`<div class="pass_name">${translation.pass}: ${ticket.pass.name}</div>`) : ''}
    `)
    .join('');
}